import { formatDate } from '../../../../../../utils/tableFuncs'
import { formatCurrency } from '../../../utils/formatCurrency'
import tollReportAccountDetailsColumns from './tollReportAccountDetailsColumns'
import type { Row } from '@tanstack/react-table'
import type { TollReportAccountDetails } from '../../../../../../types'
import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { useSearchParams } from 'react-router-dom'

type TollReportAccountDetailsProps = {
  data: any
  isLoading?: boolean
}
function TollReportAccountDetailsTable({ data, isLoading }: TollReportAccountDetailsProps) {
  const columns = tollReportAccountDetailsColumns()

  return (
    <GenericTable
      className="max-h-[50vh]"
      isLoading={isLoading}
      data={data}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} />
      }}
    />
  )
}

export default TollReportAccountDetailsTable

function MobileCardContent({ row }: { row: Row<TollReportAccountDetails> }) {
  const data = [
    {
      label: 'Dato',
      value: formatDate(row.original.transactionDate) || '',
    },
    {
      label: 'Tidspunkt',
      value: formatDate(row.original.transactionTime, 'HH:mm') || '',
    },
    {
      label: 'Sted',
      value: row.original.tollStation || '',
    },
    {
      label: 'Regnr',
      value: useSearchParams()?.[0]?.get('regNo') || '',
    },
    {
      label: 'Brikke-ID',
      value: row.original.referenceNo || '',
    },
    {
      label: 'Felt',
      value: row.original.field || '',
    },
    {
      label: 'Beløp',
      value: formatCurrency(row.original.amount),
    },
  ]
  const header = `Transaksjon - ${formatDate(row.original.transactionDate)}`
  return <TableMobileCardContent header={header} data={data} />
}
